<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
    v-card
      v-card-text
        .text-center.neutral700--text.mt-10
          v-icon.mb-5(size="55" color="success500") $yzi-ticket-01
          template(v-if="customer && selectedOffer")
            .text-md.font-semibold.mb-4 {{ customer.name }} has applied an offer!
            y-chip.round-xl.pa-4.info.d-block.mb-4
              .d-flex
                v-icon(color="info500") $yzi-gift-02
                .text-left.ml-3
                  .text-sm.font-semibold {{ selectedOffer.offer.name }}
                  .text-sm {{ selectedOffer.code }}
            simple-profile(:name="customer.name" :phone="customer.phone")
            v-btn.button-sm.underline.mt-8(text @click="handleBackToHomepage") Back to homepage
          template(v-else)
            v-skeleton-loader(type="list-item-two-line@3")
</template>

<script>

import StampCollectedTopIcon from "@/components/marketing/merchantapp/stamps/StampCollectedTopIcon.vue";
import PointCollectedTopIcon from "@/components/marketing/merchantapp/points/PointCollectedTopIcon.vue";
import SimpleProfile from "@/components/marketing/merchantapp/SimpleProfile.vue";

export default {
  components: {
    SimpleProfile,
    PointCollectedTopIcon,
    StampCollectedTopIcon
  },
  props: {
    open: {
      type: Boolean,
    },
    customer: {
      type: Object,
      required: true,
    },
    selectedOffer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },
    handleBackToHomepage() {
      this.$emit('backToHomepage')
      this.closeDialog()
    }
  },
}
</script>

<style scoped>
.info {
  background-color: #E4F2FF !important
}
</style>
